import Logger from '../../server/src/logger';
import { getUrl } from './helpers';

const cache = {};

export const GET_MENU_SUCCESS = 'header/GET_MENU_SUCCESS';

const onSuccess = platformId => (products, response) => {
  const { etag } = response.headers;

  if (etag) {
    Logger.info(`caching menu result for ${platformId}: ${etag}`);
    cache[platformId] = { etag, products };
  }

  return {
    type: GET_MENU_SUCCESS,
    payload: { products },
  };
};

const onFailure = platformId => error => {
  const statusCode = error.response && error.response.status;

  if (statusCode === 304) {
    Logger.debug(
      `using menu cache for ${platformId}: ${cache[platformId].etag}`,
    );

    return {
      type: GET_MENU_SUCCESS,
      payload: {
        products: cache[platformId].products,
      },
    };
  }
};

export const getMenuAction = (platformId, useCache) => {
  const etag = cache[platformId] && cache[platformId].etag;
  const headers = {
    'X-Use-Cache': useCache ? 'true' : 'false',
  };

  if (etag) {
    headers['If-None-Match'] = etag;
  }

  return {
    payload: {
      url: getUrl('MS_HEADER_MENU_APPLI_HOST', `/api/menus/${platformId}`),
      method: 'GET',
      headers,
      onSuccess: onSuccess(platformId),
      onFailure: onFailure(platformId),
    },
  };
};
